import firebaseApp from '@/app/database/firebase-app';
import axios from 'axios';
import { getAuth } from 'firebase/auth';

axios.defaults.headers.common.Accept = 'application/json';
axios.defaults.timeout = 0;

const htmlToPdf = async (html: string) => {
  const auth = getAuth(firebaseApp);
  const response = await axios.post(
    `/api/convert/htmlToPdf`,
    { html: html },
    {
      headers: { token: await auth.currentUser.getIdToken() },
      responseEncoding: 'binary',
      timeout: 0,
      responseType: 'blob'
    }
  );

  return response.data;
};

export default {
  htmlToPdf
};
